export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heslo"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zrušení"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pokračovat"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte potvrzovací heslo"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrzovací heslo"])}
}